var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-icp"},[_c('a',{attrs:{"href":"https://beian.miit.gov.cn/"}},[_vm._v("蜀ICP备2021007621号-2")])])}]

export { render, staticRenderFns }